module.exports = __webpack_public_path__ + "static/media/ricardo-perez-street-selected.6713d1bd.svg";